var Configs = {
  Release: {
    Env: "Release",
    FirebaseFunctionUrl: "https://us-central1-chift1.cloudfunctions.net",
    FirebaseConfig: {
      apiKey: "AIzaSyBpZaCaGYV8RS57Y-sPDPgAeTHdnWYWJA0",
      authDomain: "chift1.firebaseapp.com",
      databaseURL: "https://chift1.firebaseio.com",
      projectId: "chift1",
      storageBucket: "chift1.appspot.com",
      messagingSenderId: "605493593644",
      appId: "1:605493593644:web:306f71bc5adae78cb3b389",
      measurementId: "G-Y4C1FVRZ4D",
    },
    Stripe: {
      PublicKey:
        "pk_live_51HCq9nJe0mL5QUbWIhxchzqGqJCHg73vUnLEA18OUgvdO54D86kWxgtwvqvyvjkESxc9BUibmsOiZRKp7sf5NSxH00bMIZb4SI",
    },
    GoogleGeolocation: "AIzaSyDWvIuY_pYVGIFZ1veLuq8ynuPPZRlt7JI",
  },
  Staging: {
    Env: "Staging",
    FirebaseFunctionUrl: "https://us-central1-chift-1778d.cloudfunctions.net",
    FirebaseConfig: {
      apiKey: "AIzaSyA9xt1Fp-SvAVgV3xtElnhl2wHjomlH4wY",
      authDomain: "chift-1778d.firebaseapp.com",
      databaseURL: "https://chift-1778d.firebaseio.com",
      projectId: "chift-1778d",
      storageBucket: "chift-1778d.appspot.com",
      messagingSenderId: "676996593567",
      appId: "1:676996593567:web:d0a932c1f95ffc9fe1efaa",
      measurementId: "G-GLDB7DEB8C",
    },
    Stripe: {
      PublicKey: "pk_test_TYooMQauvdEDq54NiTphI7jx",
    },
    GoogleGeolocation: "AIzaSyANlDfZRkvvkQl5FK410h_28TuFwNjB1ws",
  },
  Local: {
    Env: "Local",
    FirebaseFunctionUrl: "https://us-central1-chift-1778d.cloudfunctions.net", // 'http://localhost:5000/chift-1778d/us-central1'
    FirebaseConfig: {
      apiKey: "AIzaSyA9xt1Fp-SvAVgV3xtElnhl2wHjomlH4wY",
      authDomain: "chift-1778d.firebaseapp.com",
      databaseURL: "https://chift-1778d.firebaseio.com",
      projectId: "chift-1778d",
      storageBucket: "chift-1778d.appspot.com",
      messagingSenderId: "676996593567",
      appId: "1:676996593567:web:d0a932c1f95ffc9fe1efaa",
      measurementId: "G-GLDB7DEB8C",
    },
    Stripe: {
      PublicKey:
        "pk_test_51HCq9nJe0mL5QUbWHQAwvCZPNuwJ3LLWfq4YpFJ6aiWT8b4X9n0sGu7wIrhsETbMAE3KNI52pCTUPpkLaBdnIfrg002SSq94NP",
    },
    GoogleGeolocation: "AIzaSyANlDfZRkvvkQl5FK410h_28TuFwNjB1ws",
  },
}

let Config = Configs.Release
if (process.env.NODE_ENV === "development") {
  Config = Configs.Local
  console.log(Config.Env + " Environment")
} else if (
  (window.location.hostname.endsWith(".firebaseapp.com") ||
    window.location.hostname.endsWith(".web.app")) &&
  !window.location.hostname.startsWith("chift1")
) {
  Config = Configs.Staging
  console.log(Config.Env + " Environment")
} else {
  Config = Configs.Release
  // No console.log Here.
}

export default Config
